const commonUrl = 'http://code.leaplearner.com'

let getUrl = function () {
    return commonUrl;
}

export default {
    getUrl: getUrl,
    leapBridge: LeapBridge,
}


// WEBPACK FOOTER //
// ./src/common.js